import { defineMessages } from 'react-intl-next';

export const i18n: {
    watchedByMe: {
        id: string;
        defaultMessage: string;
        description: string;
    };
} = defineMessages({
	watchedByMe: {
		id: 'search-page.filters.names.work-watching',
		defaultMessage: 'Work I’m watching',
		description: 'Label for filtering for watched by the current user items',
	},
});
